export default __webpack_public_path__ + "static/media/Group 18363.f37735b6.png";